<script setup>
import { useNuxtApp } from '#app'
import AlertIconDanger from '@/components/Icons/AlertIconDanger.vue'

const props = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  error: Object,
})

const { $project, $global, $_, $permissions } = useNuxtApp()
</script>

<template>
  <div>
    <NuxtLayout name="default">
      <div class="flex flex-col items-center justify-center">
        <AlertIconDanger :default-fill="false" icon-class="fill-green" class="mt-10" />
        <h1 class="mb-3 mt-6 text-2xl">{{ $_('pages/error.heading', 'Něco se pokazilo.') }}</h1>
        <p>
          {{ $_('pages/error.subheading.text', 'Tady bude nějaký text s odkazem kam může uživatel pokračovat') }}
          <a href="/dashboard" class="text-green underline">
            {{ $_('pages/error.subheading.link', 'Odkaz na homepage.') }}
          </a>
        </p>
        <img v-if="error.statusCode === 404" class="mt-20 w-1/2" src="@/assets/img/404.png" alt="error" />
        <img v-else class="mt-12 w-1/2" src="@/assets/img/500.png" alt="error" />
        <a
          class="mb-10 mt-10 text-green underline"
          :href="'mailto:' + $_('pages/error.suppor_email', 'support@jrkdigital.eu')"
        >
          {{ $_('pages/error.suppor_email', 'support@jrkdigital.eu') }}
        </a>
      </div>
    </NuxtLayout>
  </div>
</template>
